<template>
    <div class="
        w:1056 mx:auto
        {opacity:0!;pointer-events:none}_.slick-arrow.slick-disabled
        {bg:url(images/banner_arrow2.svg);z:2}_.slick-arrow
        {bg:url(images/banner_arrow2.svg)}_.slick-arrow:focus
        {bg:url(images/banner_arrow_hover2.svg)!}_.slick-arrow:hover
        {mt:20;left:-37!}_.slick-prev
        {mt:20;rotate(180deg);right:-37!}_.slick-next
        {content:''!}_.slick-arrow::before
        {bottom:-51;w:calc(100%-32px);h:16;bg:y500;r:8;left:16;flex}_.slick-dots
        {flex:1;h:16;bg:y500;r:8;m:0}_.slick-dots_li
        {d:none}_.slick-dots_li_button
        {flex:1;h:16;bg:white}_.slick-dots_li.slick-active
    ">
        <div ref="container">
            <slot></slot>
        </div>
    </div>
</template>

<script setup>
    const container = ref();

    onMounted(() => $(container.value).slick({ arrows: true, dots: true, infinite: false, slidesToShow: 3, slidesToScroll: 3 }));
</script>
